import { FilterProperty } from "./types";

export const TABLE_ITEMS = [
  { label: "SKU", property: FilterProperty.Sku },
  { label: "Brand", property: FilterProperty.Brand },
  { label: "Model", property: FilterProperty.Model },
  { label: "Main Category", property: FilterProperty.MainCategory },
  { label: "Sub Category", property: FilterProperty.SubCategory },
  { label: "Edition", property: FilterProperty.Edition },
];

export const TABLE_ITEMS_LABELS = {
  [FilterProperty.Sku]: "SKU",
  [FilterProperty.Brand]: "Brand",
  [FilterProperty.Model]: "Model",
  [FilterProperty.MainCategory]: "Main Category",
  [FilterProperty.SubCategory]: "Sub Category",
  [FilterProperty.Edition]: "Edition",
};

